import React, { Component } from 'react'
import { connect } from 'react-redux'
import history from '../../../routes/history';
import * as actionCreator from '../../../redux/actions/data-action';
import connectCommon from '../../common/common-hoc';
import { assessmentStatus, termsReponse } from '../../../Constants';

import {
    AssessmentContainer,
    AssessmentContentCenteredSection,
    AssessmentBody,
    AssessmentContent,
    AssessmentContentHeader,
    AssessmentNavigationPrevious,
    AssessmentNavigationNext,
    AssessmentFooter,
    AssessmentContentError,
    AssessmentContentAction,
    AssessmentContentActionButton
} from '../../assessment/common';

const backLink = "/TermsAndConditions";
const nextLink = "/FinalTermination";

class TermsDeclineScreenFrench extends Component {
    constructor(props) {
        super(props);

        this.state = { errorMessage: '' };

        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    handleBack() {
        const { setTerms, setAssessmentStatus } = this.props;
        setAssessmentStatus(assessmentStatus.InProgress);
        history.push(backLink);
    }

    handleNext() {
        this.setState({ errorMessage: 'Please provide a response' });
    }

    render() {
        return (
            <AssessmentContainer>
                <AssessmentContentHeader></AssessmentContentHeader>
                <AssessmentBody>
                    <AssessmentContent>
                        <AssessmentContentCenteredSection>
                            Vous avez refusé de remplir le Conners 4. Pour de plus amples renseignements, veuillez communiquer avec votre administrateur du Conners 4.
                        </AssessmentContentCenteredSection>
                        <AssessmentContentCenteredSection>
                        Si vous souhaitez remplir le Conners 4, veuillez retourner à la page relative aux renseignements juridiques et cliquer sur "J`accepte" pour poursuivre.
                        </AssessmentContentCenteredSection>
                        <AssessmentContentError>
                            {this.state.errorMessage}
                        </AssessmentContentError>
                        <AssessmentContentAction>
                        <AssessmentContentActionButton styleType='arrows' onClick={this.handleBack}>{'<'}</AssessmentContentActionButton>
                            {/* <AssessmentContentActionButton onClick={this.handleExit}>Close</AssessmentContentActionButton> */}
                        </AssessmentContentAction>
                    </AssessmentContent>
                </AssessmentBody>
                <AssessmentFooter includeProgress={false} includeLogo={true}></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

export default connect(null, actionCreator)(connectCommon(TermsDeclineScreenFrench));